import React, { useEffect, useState } from 'react';
import { checkWebGPU } from '../slm/webllmClient';
import { useT } from '../i18n/langContext.js';

// reason='quota': the normal AI-quota-exhausted flow, offers local (if a
// real GPU adapter checks out) or lite. reason='gpu': the local model just
// failed with a GPU/adapter error — we already know local won't work, so
// skip the re-probe (which would just fail again) and go straight to lite.
export default function QuotaDialog({ mode, onChoice, reason = 'quota', slmModelName, slmModelSize = '' }) {
  const t = useT();
  const resolvedModelName = slmModelName || t('quota.button.defaultModelName');
  const [gpuOk, setGpuOk] = useState(null); // null=checking, true/false

  useEffect(() => {
    if (reason === 'gpu') {
      setGpuOk(false);
    } else if (mode === 'chat') {
      checkWebGPU().then(setGpuOk);
    } else {
      setGpuOk(false); // guide wizard never offers local SLM
    }
  }, [mode, reason]);

  const canLocal = gpuOk === true;

  return (
    <div className="quota-dialog-backdrop" onClick={() => onChoice('cancel')}>
      <div className="quota-dialog" onClick={e => e.stopPropagation()}>
        <div className="quota-dialog__icon">{reason === 'gpu' ? '⚠' : '⚡'}</div>
        <div className="quota-dialog__title">{reason === 'gpu' ? t('quota.title.gpu') : t('quota.title.quota')}</div>
        <div className="quota-dialog__body">
          {reason === 'gpu'
            ? t('quota.body.gpu')
            : gpuOk === null
            ? t('quota.body.checking')
            : canLocal
            ? t('quota.body.canLocal')
            : t('quota.body.serverLite')}
        </div>
        {gpuOk !== null && (
          <div className="quota-dialog__actions">
            {canLocal && (
              <button className="quota-btn quota-btn--primary" onClick={() => onChoice('local')}>
                {t('quota.button.localLabel', { model: resolvedModelName })}
                <span className="quota-btn__sub">{t('quota.button.localSub')}{slmModelSize ? ` · ${slmModelSize}` : ''}</span>
              </button>
            )}
            <button className="quota-btn quota-btn--secondary" onClick={() => onChoice('lite')}>
              {t('quota.button.liteLabel')}
              <span className="quota-btn__sub">{t('quota.button.liteSub')}</span>
            </button>
            <button className="quota-btn quota-btn--cancel" onClick={() => onChoice('cancel')}>
              {t('quota.button.cancel')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
